"use client";

import { useRef, useState } from "react";
import { useGlobalStore } from "~/stores/store-provider";
import Sidebar from "~/components/sidebar/sidebar";
import ChatHome from "~/components/chat/chat-home";
import DatabaseConnectorMenu from "../database/database-connector-menu";
import { TbDatabasePlus } from "react-icons/tb";
import LiveSession from "~/components/live-session/live-session";

const SessionContainer = ({ sessionId }: { sessionId?: string | undefined }) => {
  const { collapsed, toggleCollapse } = useGlobalStore((state: any) => state);
  const [isDatabaseModalOpen, setIsDatabaseModalOpen] = useState(false);
  const databaseModalRef = useRef<HTMLDialogElement>(null);

  const openDatabaseModal = () => {
    setIsDatabaseModalOpen(true);
    databaseModalRef.current?.showModal();
  };

  const closeDatabaseModal = () => {
    setIsDatabaseModalOpen(false);
    databaseModalRef.current?.close();
  };

  return (
    <div className="flex flex-row h-screen w-full">
      <div className="h-full">
        <Sidebar />
      </div>
      <div className="h-full grow overflow-hidden">
        <button
          className={`btn btn-ghost fixed top-4 z-30 transition-[left] duration-150 ease-in-out ${
            collapsed ? "left-14" : "left-80"
          }`}
          onClick={openDatabaseModal}
        >
          <TbDatabasePlus size={18} />
          Data Connections
        </button>
        {sessionId ? <LiveSession sessionId={sessionId} /> : <ChatHome onOpenDatabaseModal={openDatabaseModal} />}
      </div>
      <DatabaseConnectorMenu
        ref={databaseModalRef}
        isOpen={isDatabaseModalOpen}
        onClose={closeDatabaseModal}
      />
    </div>
  );
};

export default SessionContainer;
